import { R } from '@utils/currency'

export const totalValue = (riskProducts) =>
  riskProducts
    .reduce((accumulator, riskProduct) => R(riskProduct.value).value + accumulator, 0)

export const totalMonthlyContributions = (riskProducts) =>
  riskProducts
    .reduce((accumulator, riskProduct) => R(riskProduct.monthly_contribution).value + accumulator, 0)
